import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
  Chip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  CircularProgress,
  Divider,
  Grid,
} from '@mui/material';
import {
  Edit,
  Delete,
  Add,
  ConfirmationNumber,
  Send,
  RadioButtonChecked,
} from '@mui/icons-material';
import API from "../../../utils/API";
import utils from "../../../utils/utils";
import FloorPlan from "../../newfloorplan/Floorplan";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../../utils/authContext";

export default function TicketCategory(props) {
  const location = useLocation();
  const { showrunner } = useAuth();

  const initSeatState = {
    selectedSeats: {},
    seatClickTracker: {},
    seatIndex: {}
  }
  const [show, setShow] = useState({})
  const [subCategory, setSubCategory] = useState({})
  const [activeCategory, setActiveCategory] = useState(0)
  const [activeCategoryEdit, setActiveCategoryEdit] = useState({})
  const [activeSubCategoryEdit, setActiveSubCategoryEdit] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [category, setCategory] = useState(false)
  const [canPublish, setCanPublish] = useState(true)
  const [prod, setProd] = useState({})
  const [publishChecklist, setPublishChecklist] = useState({})
  const [floorplan, setFloorplan] = useState([])
  const [seatState, setSeatState] = useState(initSeatState)
  const [ticketCategories, setTicketCategories] = useState({ categories: [], totals: {} })
  const [newCategory, setNewCategory] = useState({})
  const [total, setTotal] = useState(0)
  const [showID, setShowID] = useState(0)
  const [theater, setTheater] = useState({})
  const [checkoutInfo, setCheckoutInfo] = useState({})

  const [subCategoryModalOpen, setSubCategoryModalOpen] = useState(false)
  const [subCategoryEditModalOpen, setSubCategoryEditModalOpen] = useState(false)
  const [sendTicketModalOpen, setSendTicketModalOpen] = useState(false)
  const [categoryModalOpen, setCategoryModalOpen] = useState(false)
  const [confirmCategoryDelete, setConfirmCategoryDelete] = useState(false)
  const [ticketCategoriesModalOpen, setTicketCategoriesModalOpen] = useState(false)
  const [editTicketModalOpen, setEditTicketModalOpen] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!showrunner) return;
    reset()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showrunner])

  useEffect(() => {
    console.log("activeCategoryEdit", activeCategoryEdit)
  }, [activeCategoryEdit])

  function reset() {
    const params = new URLSearchParams(location.search);
    const paramsShowID = params.get("showID");
    if (paramsShowID) {
      setShowID(paramsShowID);
    }
    API.getShow(paramsShowID)
      .then(res => {
        console.log("Show", res.data)
        setShow(res.data)
      })


    API.getShowManage(paramsShowID, showrunner.id)
      .then(res => {
        const { can_publish_checklist } = res.data
        setPublishChecklist(can_publish_checklist)
        for (let key in can_publish_checklist) {
          if (!can_publish_checklist[key]) {
            setCanPublish(false)
            return
          }
        }
      })

    let seatIndex
    API.getEventTix(paramsShowID)
      .then(res => {
        console.log("Tix", res.data)
        if (res.data.theater) {
          setTheater(res.data.theater)
          setFloorplan(res.data.theater.floorplan.sectors)
        }
        resetTicketCategories(paramsShowID)

        setProd(res.data.prod)
        setSeatState(prevState => ({ ...prevState, seatIndex }));

      })
  }

  function resetTicketCategories(id) {
    API.getTicketCategories(id)
      .then(res => {
        setTicketCategories(res.data)
      })
  }

  function addNewTicketCategory(e) {
    e.preventDefault();
    setLoading(true);
    const req = newCategory;
    req["showID"] = showID;
    API.addTicketCategory(req)
      .then(res => {
        if (floorplan.length < 1) {
          const addTixReq = { showID, numTix: newCategory.numTix, category: res.data.id };
          API.addTickets(addTixReq)
            .then(res2 => {
              utils.sendAlert("New ticket category added", "success");
              resetTicketCategories(showID);
              setTicketCategoriesModalOpen(false);
              console.log("res2", res2)
              props.reset(showID, showrunner.id);
            })
        } else {
          utils.sendAlert("New ticket category added", "success");
          resetTicketCategories(showID);
          setTicketCategoriesModalOpen(false);
          props.reset(showID, showrunner.id);
        }
      })
      .catch(err => {
        utils.sendAlert("Error adding ticket category", "error");
      })
      .finally(() => {
        setLoading(false);
      });
  }

  function addSubCategory(e) {
    e.preventDefault()
    setLoading(true);
    const req = subCategory
    req["category"] = activeCategory
    API.addSubcategory(req)
      .then(res => {
        reset();
        utils.sendAlert("Subcategory Added", "success");
        setSubCategoryModalOpen(false)
      })
      .catch(err => {
        console.log(err)
        utils.sendAlert("Error adding subcategory", "error");
      })
      .finally(() => {
        setLoading(false);
      });
  }

  function handleSubCategoryChange(e) {
    const { name, value } = e.target
    setSubCategory({ ...subCategory, [name]: value })
  }

  function seatClick(data, cb) {
    const { selectedSeats, seatClickTracker } = seatState
    console.log("SeatState", seatState)
    const { seat, price } = data
    console.log("seat", seat)
    if (selectedSeats[seat]) {
      delete selectedSeats[seat]
      setTotal(oldNum => oldNum - price)
    } else {
      selectedSeats[seat] = data
      setTotal(oldNum => oldNum + price)
    }
    seatClickTracker[seat] = cb

    setSeatState(prevState => ({ ...prevState, selectedSeats, seatClickTracker }));
  }


  function handleSendTicket(e) {
    const { name, value } = e.target
    setCheckoutInfo({ ...checkoutInfo, [name]: value })
  }

  function handleNewTicketCategoryData(e) {
    setNewCategory({ ...newCategory, [e.target.name]: e.target.value });
  }

  function handleCategoryEdit(e) {
    const { name, value } = e.target
    setActiveCategoryEdit({ ...activeCategoryEdit, [name]: value })
  }

  function handleSubCategoryEdit(e) {
    const { name, value } = e.target
    setActiveSubCategoryEdit({ ...activeSubCategoryEdit, [name]: value })
  }


  function updateCategory() {
    setLoading(true);
    API.editCategory(activeCategoryEdit)
      .then(res => {
        utils.sendAlert("Category Updated", "success")
        setCategoryModalOpen(false);
        reset();
        setActiveCategoryEdit({})
      })
      .catch(err => {
        const { error } = err.response.data
        utils.sendAlert(error, "error")
      })
      .finally(() => {
        setLoading(false);
      });
  }

  function updateSubCategory() {
    setLoading(true);
    API.editSubcategory(activeSubCategoryEdit)
      .then(res => {
        utils.sendAlert("Subcategory Updated", "success")
        setSubCategoryEditModalOpen(false);
        reset();
        setActiveSubCategoryEdit({})
      })
      .catch(err => {
        utils.sendAlert("Error updating subcategory", "error");
      })
      .finally(() => {
        setLoading(false);
      });
  }

  function convertTicketCategories(array) {
    return array.reduce((acc, category) => {
      const { id, name, price, discount, show, total_tickets, tickets_taken, tickets_available, subcategories, numSelected } = category;

      acc[name] = {
        id,
        name,
        price,
        discount,
        show,
        total_tickets,
        tickets_taken,
        tickets_available,
        subcategories: subcategories || {},
        numSelected: numSelected || 0,
      };

      // Convert subcategories array to object if it exists
      if (Array.isArray(subcategories)) {
        acc[name].subcategories = subcategories.reduce((subAcc, subcategory) => {
          subAcc[subcategory.name] = subcategory;
          return subAcc;
        }, {});
      }

      return acc;
    }, {});
  }

  function submitGratis() {
    if (!showID) return;
    setLoading(true);
    const formattedCategories = convertTicketCategories(ticketCategories.categories);
    const req = {
      checkoutInfo,
      seats: seatState.selectedSeats,
      showID,
      freeSeating: floorplan.length > 0 ? false : true,
      ticketCategories: formattedCategories,
    }
    Object.keys(req.ticketCategories).forEach(key => {
      const category = req.ticketCategories[key];
      if (category.id === activeCategory) {
        category.numSelected = parseInt(checkoutInfo.numTickets);
      }
    });

    console.log("Req", req)
    API.submitGratis(req)
      .then(res => {
        setSendTicketModalOpen(false)
        setSeatState(initSeatState)
        if (res.data.message && res.data.message === "error") {
          utils.sendAlert("There was an error sending your tickets. ", "error")
        } else {
          utils.sendAlert("Tickets sent! ", "success")
          reset();
        }
      })
      .catch(err => {
        utils.sendAlert("Tickets failed to send. Please try again.", "error")
      })
      .finally(() => {
        setLoading(false);
      });
  }



  return (
    <Box sx={{ p: 3 }}>
      {/* Header */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h4" fontWeight="bold">
          {prod.name || 'Ticket Management'}
        </Typography>
        <Box sx={{ display: 'flex', gap: 2 }}>
          {floorplan.length > 0 ? (
            <Button
              variant="outlined"
              startIcon={<Send />}
              onClick={() => {
                if (Object.keys(seatState.selectedSeats).length < 1) return;
                setSendTicketModalOpen(true);
              }}
              disabled={Object.keys(seatState.selectedSeats).length < 1}
            >
              Send Tickets
            </Button>
          ) : (
            <Button
              variant="outlined"
              startIcon={<Send />}
              onClick={() => {
                if (!category) return;
                setSendTicketModalOpen(true);
              }}
              disabled={!category}
            >
              Send Tickets
            </Button>
          )}
          <Button
            variant="contained"
            startIcon={<Add />}
            onClick={() => setTicketCategoriesModalOpen(true)}
          >
            Add Category
          </Button>
          <Button
            variant="outlined"
            startIcon={<Add />}
            onClick={() => {
              if (!category) return;
              setSubCategoryModalOpen(true);
            }}
            disabled={!category}
          >
            Add Subcategory
          </Button>
        </Box>
      </Box>

      {/* Ticket Categories Table */}
      <Card sx={{ mb: 3 }}>
        <CardContent sx={{ p: 0 }}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: 'grey.50' }}>
                  <TableCell sx={{ fontWeight: 'bold' }}>Select</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Ticket Category</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Total Tickets</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Tickets Available</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Tickets Sold</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Ticket Price</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {/* Total Row */}
                <TableRow sx={{ backgroundColor: 'grey.100' }}>
                  <TableCell></TableCell>
                  <TableCell>
                    <Typography variant="body2" fontWeight="bold">Total</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2" fontWeight="bold">
                      {ticketCategories.totals?.total_tickets || 0}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2" fontWeight="bold">
                      {ticketCategories.totals?.total_tickets ? 
                        (ticketCategories.totals.total_tickets - ticketCategories.totals.tickets_taken) : 0}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2" fontWeight="bold">
                      {ticketCategories.totals?.tickets_taken || 0}
                    </Typography>
                  </TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                </TableRow>
                
                {/* Category Rows */}
                {ticketCategories.categories?.map(category => (
                  <React.Fragment key={category.id}>
                    <TableRow hover>
                      <TableCell>
                        <Radio
                          checked={activeCategory === category.id}
                          onChange={() => {
                            setCategory(category);
                            setActiveCategory(category.id);
                          }}
                          name="category"
                        />
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2" fontWeight="medium">
                          {category.name}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2">
                          {floorplan.length < 1 ? category.total_tickets : null}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2">
                          {floorplan.length < 1 ? category.total_tickets - category.tickets_taken : null}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2">
                          {category.tickets_taken}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2" fontWeight="medium">
                          {category.subcategories?.length > 0 ? "" : `$${category.price}`}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', gap: 1 }}>
                          <IconButton
                            size="small"
                            onClick={() => {
                              setCategoryModalOpen(true);
                              setActiveCategoryEdit(category);
                            }}
                            color="primary"
                          >
                            <Edit fontSize="small" />
                          </IconButton>
                          <IconButton
                            size="small"
                            onClick={() => {
                              setConfirmCategoryDelete(true);
                              setActiveCategoryEdit(category);
                            }}
                            color="error"
                          >
                            <Delete fontSize="small" />
                          </IconButton>
                        </Box>
                      </TableCell>
                    </TableRow>
                    
                    {/* Subcategory Rows */}
                    {category.subcategories?.map((sub) => (
                      <TableRow key={sub.id} sx={{ backgroundColor: 'grey.25' }}>
                        <TableCell></TableCell>
                        <TableCell sx={{ pl: 4 }}>
                          <Typography variant="body2" color="text.secondary">
                            {sub.name}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" color="text.secondary">
                            {!floorplan ? sub.total_tickets : null}
                          </Typography>
                        </TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell>
                          <Typography variant="body2" color="text.secondary">
                            ${sub.price}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Box sx={{ display: 'flex', gap: 1 }}>
                            <IconButton
                              size="small"
                              onClick={() => {
                                setSubCategoryEditModalOpen(true);
                                setActiveSubCategoryEdit(sub);
                              }}
                              color="primary"
                            >
                              <Edit fontSize="small" />
                            </IconButton>
                            <IconButton
                              size="small"
                              onClick={() => {
                                setCategoryModalOpen(true);
                                setActiveSubCategoryEdit(sub);
                              }}
                              color="error"
                            >
                              <Delete fontSize="small" />
                            </IconButton>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))}
                  </React.Fragment>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>

      {/* Floor Plan */}
      {floorplan.length > 0 && (
        <Card sx={{ mb: 3 }}>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Seat Selection
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Selected: {seatState.selectedSeats ? Object.keys(seatState.selectedSeats).join(", ") : "No seats selected"}
            </Typography>
            <Box sx={{ 
              display: 'flex', 
              flexDirection: 'column', 
              alignItems: 'center',
              mt: 2,
              p: 2,
              backgroundColor: 'grey.50',
              borderRadius: 2
            }}>
              <Box sx={{ 
                width: '80%', 
                height: 40, 
                backgroundColor: 'primary.main', 
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: 1,
                mb: 2,
                fontWeight: 'bold'
              }}>
                Stage
              </Box>
              <FloorPlan 
                eventId={showID} 
                seatClick={seatClick} 
                selectedSeats={seatState.selectedSeats}
                theater={theater} 
                isEventManager={true} 
              />
            </Box>
          </CardContent>
        </Card>
      )}



      {/* Add Subcategory Dialog */}
      <Dialog 
        open={subCategoryModalOpen} 
        onClose={() => setSubCategoryModalOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Add a new Subcategory</DialogTitle>
        <DialogContent>
          <Box component="form" onSubmit={addSubCategory} sx={{ mt: 2 }}>
            <Typography variant="body2" gutterBottom>
              Set a new ticket subcategory
            </Typography>
            <TextField
              fullWidth
              label="Subcategory Name"
              name="name"
              onChange={handleSubCategoryChange}
              sx={{ mb: 2 }}
              required
            />
            <TextField
              fullWidth
              label="Ticket Price"
              name="price"
              type="number"
              onChange={handleSubCategoryChange}
              sx={{ mb: 2 }}
              required
              inputProps={{ min: 0, step: 0.01 }}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setSubCategoryModalOpen(false)}>
            Cancel
          </Button>
          <Button 
            onClick={addSubCategory} 
            variant="contained"
            disabled={loading}
          >
            {loading ? <CircularProgress size={20} /> : 'Add'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Edit Subcategory Dialog */}
      <Dialog 
        open={subCategoryEditModalOpen} 
        onClose={() => setSubCategoryEditModalOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Edit Subcategory</DialogTitle>
        <DialogContent>
          <Box component="form" onSubmit={updateSubCategory} sx={{ mt: 2 }}>
            <TextField
              fullWidth
              label="Subcategory Name"
              name="name"
              value={activeSubCategoryEdit.name || ''}
              onChange={handleSubCategoryEdit}
              sx={{ mb: 2 }}
              required
            />
            <TextField
              fullWidth
              label="Price"
              name="price"
              type="number"
              value={activeSubCategoryEdit.price || ''}
              onChange={handleSubCategoryEdit}
              sx={{ mb: 2 }}
              required
              inputProps={{ min: 0, step: 0.01 }}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setSubCategoryEditModalOpen(false)}>
            Cancel
          </Button>
          <Button 
            onClick={updateSubCategory} 
            variant="contained"
            disabled={loading}
          >
            {loading ? <CircularProgress size={20} /> : 'Update'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Send Ticket Dialog */}
      <Dialog 
        open={sendTicketModalOpen} 
        onClose={() => setSendTicketModalOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Send Free Tickets</DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2 }}>
            {floorplan && floorplan.floorPlan ? null : (
              <>
                <Typography variant="body2" sx={{ mb: 2 }}>
                  Seats: {seatState.selectedSeats ? Object.keys(seatState.selectedSeats).join(", ") : "No seats selected"}
                </Typography>
                <TextField
                  fullWidth
                  label="Full name"
                  name="fullName"
                  onChange={handleSendTicket}
                  sx={{ mb: 2 }}
                  required
                />
                <TextField
                  fullWidth
                  label="Email"
                  name="email"
                  type="email"
                  onChange={handleSendTicket}
                  sx={{ mb: 2 }}
                  required
                />
                {floorplan.length === 0 && (
                  <TextField
                    fullWidth
                    label="Number of tickets"
                    name="numTickets"
                    type="number"
                    onChange={handleSendTicket}
                    sx={{ mb: 2 }}
                    required
                    inputProps={{ min: 0, step: 1 }}
                  />
                )}
              </>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setSendTicketModalOpen(false)}>
            Cancel
          </Button>
          <Button 
            onClick={submitGratis} 
            variant="contained"
            disabled={loading}
          >
            {loading ? <CircularProgress size={20} /> : 'Send tickets'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Edit Category Dialog */}
      <Dialog 
        open={categoryModalOpen} 
        onClose={() => setCategoryModalOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Edit Category</DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2 }}>
            <TextField
              fullWidth
              label="Category Name"
              name="name"
              value={activeCategoryEdit.name || ''}
              onChange={handleCategoryEdit}
              sx={{ mb: 2 }}
              required
            />
            <TextField
              fullWidth
              label="Total Tickets Available"
              name="tickets_available"
              type="number"
              value={activeCategoryEdit.tickets_available || ''}
              onChange={handleCategoryEdit}
              sx={{ mb: 2 }}
              required
              inputProps={{ min: 0, step: 1 }}
            />
            {(!activeCategoryEdit.subcategories || activeCategoryEdit.subcategories.length === 0) && (
              <TextField
                fullWidth
                label="Category price"
                name="price"
                type="number"
                value={activeCategoryEdit.price || ''}
                onChange={handleCategoryEdit}
                sx={{ mb: 2 }}
                required
                inputProps={{ min: 0, step: 0.01 }}
              />
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setCategoryModalOpen(false)}>
            Cancel
          </Button>
          <Button 
            onClick={updateCategory} 
            variant="contained"
            disabled={loading}
          >
            {loading ? <CircularProgress size={20} /> : 'Update Ticket Category'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Add Ticket Category Dialog */}
      <Dialog 
        open={ticketCategoriesModalOpen} 
        onClose={() => setTicketCategoriesModalOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Add a new ticket category</DialogTitle>
        <DialogContent>
          <Box component="form" onSubmit={addNewTicketCategory} sx={{ mt: 2 }}>
            <Typography variant="body2" gutterBottom sx={{ mb: 2 }}>
              Set New Ticket Category
            </Typography>
            <TextField
              fullWidth
              label="Category Name"
              name="name"
              onChange={handleNewTicketCategoryData}
              sx={{ mb: 2 }}
              required
            />
            <TextField
              fullWidth
              label="Ticket Price"
              name="price"
              type="number"
              onChange={handleNewTicketCategoryData}
              sx={{ mb: 2 }}
              required
              inputProps={{ min: 0, step: 0.01 }}
            />
            {floorplan.length < 1 && (
              <TextField
                fullWidth
                label="Number of tickets"
                name="numTix"
                type="number"
                onChange={handleNewTicketCategoryData}
                sx={{ mb: 2 }}
                required
                inputProps={{ min: 0, step: 1 }}
              />
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setTicketCategoriesModalOpen(false)}>
            Cancel
          </Button>
          <Button 
            onClick={addNewTicketCategory} 
            variant="contained"
            disabled={loading}
          >
            {loading ? <CircularProgress size={20} /> : 'Add'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Confirm Category Delete Dialog */}
      <Dialog 
        open={confirmCategoryDelete} 
        onClose={() => setConfirmCategoryDelete(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Confirm Category Deletion</DialogTitle>
        <DialogContent>
          <Alert severity="warning" sx={{ mb: 2 }}>
            Are you sure you want to delete this category? This will not impact customers who have already used it.
          </Alert>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmCategoryDelete(false)}>
            Cancel
          </Button>
          <Button 
            onClick={() => "delete ticket categories"} 
            color="error"
            variant="contained"
          >
            Yes, delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  )
}